<div class="epk-gallery-dialog-container t-c m-l-a m-r-a bg-black dker p-b-20">

    <!-- Dialog Header -->
    <div class="gallery-dialog-header text-center flex-fs-c relative">
        <!-- Title and Index Counter -->
        <div class="modal-title text-ellipsis text-white" id="photoGalleryTitle">
            <strong>{{ getCurrentImageTitle() }}</strong> | {{ currentIndex + 1 }} of {{ data.images.length }}
        </div>

        <!-- Close Button -->
        <div class="dialogClose pointer" (click)="closeDialog()">
            <img src="../../../assets/images/close.svg" alt="Close">
        </div>
    </div>

    <!-- Image Display Container with Navigation Controls -->
    <div class="gallery-img-container relative">

        <!-- Previous Button -->
        <button *ngIf="data.images.length > 1" class="gallery-nav-btn prev-btn" (click)="prevPhoto()"
            [disabled]="currentIndex === 0" title="Previous">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
        </button>

        <!-- Current Image -->
        <img [src]="getCurrentImageUrl()" [alt]="getCurrentImageTitle()" class="gallery-img">

        <!-- Next Button -->
        <button *ngIf="data.images.length > 1" class="gallery-nav-btn next-btn" (click)="nextPhoto()"
            [disabled]="currentIndex === data.images.length - 1" title="Next">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
        </button>
    </div>
</div>